const Intercom = { getUnreadConversationCount: () => {} };

export default Intercom;
